/* eslint-disable @typescript-eslint/member-ordering */
import { inject, Injectable } from '@angular/core';

import * as grpc_web from 'grpc-web';
import { TokenService } from '@fatigue/app/core/services/token.service';
@Injectable()
export class HeaderService {
  private readonly tokenService = inject(TokenService);

  companyId?: string;
  bhAppid?: string;
  apiToken?: string;
  apiKey?: string;
  lang: string = 'en';

  setHeader(metadata: grpc_web.Metadata = {}) {
    if (this.companyId) {
      metadata['mark-health-company-id'] = this.companyId;
    }
    if (this.bhAppid) {
      metadata['mark-health-bh-appid'] = this.bhAppid;
    }
    if (this.lang) {
      metadata['mark-health-lang'] = this.lang;
    }
    if (this.tokenService.token) {
      metadata['mark-health-token-user'] = this.tokenService.token;
    }
    if (this.apiToken) {
      metadata['mark-api-token'] = this.apiToken;
    }
    if (this.apiKey) {
      metadata['mark-api-key'] = this.apiKey;
    }

    return metadata;
  }
}
